/**
 * Конвертирует токены формата dayjs в токены date-fns для NDatePicker.
 * Поддерживаются только токены, используемые в проекте (YYYY, YY, MM, DD, D).
 */
export const convertDayjsFormatToDateFns = (dayjsFormat: string): string =>
  dayjsFormat.replace(/YYYY/g, 'yyyy').replace(/YY/g, 'yy').replace(/DD/g, 'dd').replace(/D/g, 'd')
